import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as $ from 'jquery';
import { RegularComponent } from "app/admin/regular/regular.component";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Globals } from '../../globals';
import { AdminService, SectionChoice } from 'app/services/admin/AdminService';

@Component({
  selector: 'app-new-regular-choice-modal',
  templateUrl: './new-regular-choice-modal.component.html',
  styleUrls: ['./new-regular-choice-modal.component.scss']
})
export class NewRegularChoiceModalComponent implements OnInit {
    @ViewChild('newregularchoice', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;
    parent: RegularComponent;
    text: string = "";
    actionEdit: boolean = false;
    actionCreate: boolean = false;
    currentIndex: number;
    languages: string[] = [];
    localizations: any[] = [];
    choiceId: number;
    type: number = 1;
    sectionId: number = 1;
    order: number;
    action: string;
    positiveP: number = 0;
    negativeP: number = 0;

  @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
  constructor
      (
          private _AdminService: AdminService,
          private toastr: ToastrService,
          private router: Router,
          private _Globals: Globals
  )
  { }

  ngOnInit() {
      this.getLanguages();
  }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
          console.log('languages', data.result);
          let result = data.result.Result;

          if (result <= -10) {
              //this.toastr.warning('Expired token please login again.', 'ELI');
              this.router.navigate(['/login']);
              this._Globals.deleteAllStorage();
              return;
          }

          let _data = JSON.parse(data.result.Data);
          this.languages = _data;
      });
  }

  show(parent: RegularComponent, action: string, id: number, text: string, order: number): void {
      $('textarea').val(text);
      this.parent = parent;
      this.choiceId = id;
      this.text = text;
      this.order = order;
      this.action = action;
      switch (action) {
          case "edit":
              this.actionEdit = true;
              this.getChoice();
              break;
          case "create":
              this.actionCreate = true;
              break;
      }
      this.modal.show();
  }

    getChoice() {
        this._AdminService.getSectionChoice(this.choiceId).subscribe(data => {
          console.log('choice', data.result);
          this.localizations = data.result.Localizations;
          this.positiveP = data.result.PositivePoints;
          this.negativeP = data.result.NegativePoints;
      })
  }

  onShown(): void {
  }

  close(): void {
      this.modal.hide();
      this.resetActions();
  }

  resetActions() {
      this.actionCreate = false;
      this.actionEdit = false;
      $('#languagesChoice').prop('selectedIndex', 0);
      this.localizations = [];
      $('#textareaChoice').val('');
      
  }

  saveQuestion(text: string) {
      console.log('save choice');
      if (text == '') {
          this.toastr.warning('Field empty', 'ELI');
          return;
      }

      let canAddChoice = false;
      for (var i = 0; i < this.localizations.length; i++){
          if (this.localizations[i].LanguageShortCode == "en") {
              canAddChoice = true;
          }
      }

      if (!canAddChoice) {
          this.toastr.warning('English value for this choice cannot be empty.', 'ELI');
          return;
      }
      
      
      let choiceId = 0;
      if (!this.actionCreate) {
          choiceId = this.choiceId;
      }
      if (this.order == undefined) {
          this.order = 0;
      }


      let sectionChoice = new SectionChoice();

      sectionChoice.ChoiceId = choiceId;
      sectionChoice.SectionId = this.sectionId;
      sectionChoice.Order = this.order;
      sectionChoice.Text = "";
      sectionChoice.PositivePoints = parseInt($('#positive').val().toString());
      sectionChoice.NegativePoints = parseInt($('#negative').val().toString());
      sectionChoice.Localizations = this.localizations;


      this._AdminService.postSaveSectionChoice(sectionChoice).subscribe(data => {
          console.log('_PostSaveSectionChoice response', data);
          if (data.result.Result == 1) {
              this.toastr.success('Choice edited successfully.','ELI');
              this.parent.getAllSectionChoices();
              this.close();
          }
          else
          {
              this.toastr.error('Error. Please try again.', 'ELI');
          }
          //this.modalSave.emit();
      });
      //this.questionEmpty(text);
      //this.parent.insertNewRow(text);
      //this.modalSave.emit();
  }

  questionEmpty(text) {
      if (text == "") {
          $('#textareaChoice').addClass('empty');
          setTimeout(function () {
              $('#textareaChoice').removeClass('empty');
          }, 500);
          return;
      }
  }

  addLocalization(text: string, languageShortCode: string)
  {
      if (text != '')
      {
          console.log('setLocalization');
          if (this.localizations.length == 0) {
              this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
          }
          else {

              let arrayLength = this.localizations.length;
              let addNew = true;
              for (var i = 0; i < arrayLength; i++) {
                  if (this.localizations[i].LanguageShortCode == languageShortCode) {
                      //property exist
                      addNew = false;
                      this.localizations[i].Text = text;
                  }
              }
              if (addNew) {
                  //property not exist
                  this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
              }
          }
          console.log(this.localizations); 
      }   
  }

  clearTextArea() {
      $('#textareaChoice').val('');
  }

  checkData(languageShortCode: string) {
      this.clearTextArea();
      console.log('check data', this.localizations);

      //check array for display data in text area if exist
      let arrayLength = this.localizations.length;
      for (var i = 0; i < arrayLength; i++) {
          if (languageShortCode == this.localizations[i].LanguageShortCode) {
              //property exist
              let text = this.localizations[i].Text;
              $('#textareaChoice').val(text);
          }
      }
      
  }

  preventSpace(value: string, event: any) {
      if (value == null || value == "") {
          if (event.keyCode == 32) {
              return false;
          }
      }
      if (value == " ") {
          $('#textareaChoice').val('');
      }
  }

  preventLetters(event: any) {
      if (event.which < 48 || event.which > 57) {
          event.preventDefault();
          console.log('');
      }
  }

}

interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
